<template>
  <v-app>
    <AppBar v-if="showAppBar" />
    <LeftAlertPanel
      v-if="showLeftAlertPanel"
      :unread-count="leftAlertUnreadCount"
      @refresh-unread="handleLeftAlertRefreshUnread"
    />
    <v-main>
      <div class="main-background">
        <div class="content-container">
          <router-view v-slot="{ Component }">
            <transition name="fade">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </div>
    </v-main>
    
    <!-- <v-dialog max-width="500" v-model="showUpdateDialog">
      <v-card class="confirm-dialog">
        <v-card-title><span>提示</span></v-card-title>
        <v-card-text><span>发现你的系统版本不是最新,现在将刷新更新。</span></v-card-text>
        <v-card-actions>
          <v-btn color="primary" variant="flat" @click="refreshPage">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <!-- 版本更新提醒对话框 -->
    <VersionCheckDialog
      :visible="showVersionDialog"
      @immediateRefresh="handleImmediateRefresh"
    />
    
    <!-- @close="closeVersionDialog"
    @forceRefresh="handleForceRefresh" -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      location="top"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-app>
</template>

<script setup lang="ts">
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import AppBar from '@/components/AppBar.vue'
import LeftAlertPanel from '@/components/LeftAlertPanel.vue'
import { useSnackbar } from '@/composables/useSnackbar'
import VersionCheckDialog from '@/components/VersionCheckDialog.vue'
// import { useVersionCheck } from '@/composables/useVersionCheck'
import { authApi, urgentNoticeApi } from '@/services/api'

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const { snackbar, showError } = useSnackbar()
const showUpdateDialog = ref(false)
const vueVersion = ref('')

const showVersionDialog = ref(false)
// 未读数接口待接入，先保留占位
const leftAlertUnreadCount = ref(0)
// 版本检查
// const {
//   showVersionDialog,
//   closeVersionDialog,
//   // handleForceRefresh: handleVersionForceRefresh,
//   // handleImmediateRefresh: handleVersionImmediateRefresh
// } = useVersionCheck()

// console.log('版本号', useVersionCheck())
// 是否显示顶部导航栏
const showAppBar = computed(() => {
  return route.name !== 'login' && route.name !== 'landing' && userStore.token
})

// 是否显示警讯面板
const showLeftAlertPanel = computed(() => {
  return route.name !== 'landing' && route.name !== 'shareProductionProgress'
})

// 处理版本更新后的强制刷新
// const handleForceRefresh = () => {
//   handleVersionForceRefresh()
// }

const handleImmediateRefresh = () => {
  showVersionDialog.value = false;
  window.location.reload();
  localStorage.setItem('app_version', JSON.stringify({version: vueVersion.value}));
  // handleVersionImmediateRefresh()
}

const handleVersionIsUpdate = async() => {
  if(!localStorage.getItem('token')){
    return
  }
  try {
    let url = '';
    if(window.location.protocol.includes('https')){
      url = `${window.location.protocol}//${window.location.host}/assets/version.json?t=${new Date().getTime()}`; //生产
    }else{
      url = `${window.location.protocol}//${window.location.host}/src/assets/version.json?t=${new Date().getTime()}`; //测试
    }
    const res = await axios.get(url);
    
    if(res.status === 200 && res.data && res.data.version){
      vueVersion.value = res.data.version;
      let localVueVersion = JSON.parse(localStorage.getItem('app_version') || '{}').version;
      console.log('远程版本:', vueVersion.value, '本地版本:', localVueVersion,localVueVersion !== vueVersion.value);
      if(localVueVersion && localVueVersion !== vueVersion.value){
        // if(!showVersionDialog.value){
        //   showVersionDialog.value = true;
        // }
        // localStorage.setItem('app_version', vueVersion);
        handleImmediateRefresh()
      } else if (!localVueVersion) {
        localStorage.setItem('app_version', JSON.stringify({version: vueVersion.value}));
      }
    } else {
      console.warn('版本检查响应异常:', res.status, res.data);
    }
  } catch (error) {
    console.error('版本检查请求失败:', error);
  }
}

// 每次路由跳转时检查版本更新
watch(() => route.path, () => {
  handleVersionIsUpdate()
})

// 定时器引用
let multiLoginTimer: number | null = null
let multiLoginTimer2: number | null = null
let urgentNoticeTimer: number | null = null

// 监听多端登录
const listenMultiLogin = async() => {
  if(!localStorage.getItem('token')){
    return
  }
  try {
    const res = await authApi.checkToken()
    if (res.code === -40303) {
      console.log('多端登录', res.data)
      showError('登录状态失效')
      sessionStorage.clear()
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      userStore.clearUserInfo()
      router.push('/login')
      // stopMultiLoginListener()
    }
  } catch (error) {
    console.error('多端登录失败', error)
  }
}

// 轮询警讯红点（true=有未读，false=无未读）
const pollUrgentNoticeRedDot = async () => {
  if (!localStorage.getItem('token')) {
    leftAlertUnreadCount.value = 0
    return
  }
  try {
    const res = await urgentNoticeApi.redDot()
    const hasUnread =
      (res?.code === 0 && res?.data === true) || res?.data === true
    leftAlertUnreadCount.value = hasUnread ? 1 : 0
  } catch (error) {
    console.error('警讯红点轮询失败', error)
  }
}

const handleLeftAlertRefreshUnread = () => {
  // confirm 成功后先乐观更新，再立即向服务端校准一次红点状态
  leftAlertUnreadCount.value = 0
  void pollUrgentNoticeRedDot()
}

// 启动多端登录监听
const startMultiLoginListener = () => {
  // if (localStorage.getItem('token')) {
    // 立即执行一次
    listenMultiLogin()
    handleVersionIsUpdate()
    pollUrgentNoticeRedDot()
    // 每1分钟执行一次
    multiLoginTimer = setInterval(listenMultiLogin,  1 * 60 * 1000)
    // 每30秒轮询一次警讯红点
    urgentNoticeTimer = setInterval(pollUrgentNoticeRedDot, 30 * 1000)
    // multiLoginTimer2 = setInterval(handleVersionIsUpdate,  1 * 60 * 1000)
  // }
}

// 停止多端登录监听
const stopMultiLoginListener = () => {
  if (multiLoginTimer) {
    clearInterval(multiLoginTimer)
    multiLoginTimer = null
  }
  if (urgentNoticeTimer) {
    clearInterval(urgentNoticeTimer)
    urgentNoticeTimer = null
  }
}

// 组件挂载时启动监听
onMounted(() => {
  startMultiLoginListener()
  console.log('当前页面:', route)
  // 与 router.beforeEach 一致：仅当目标路由明确要求登录时才跳转登录页（避免拦截 Landing、/maintain 等公开页）
  if (
    !localStorage.getItem('token') &&
    route.meta.requiresAuth === true
  ) {
    router.push({ name: 'login', query: { redirect: route.fullPath } })
  }
})

// 组件卸载时清理定时器
onUnmounted(() => {
  stopMultiLoginListener()
})

console.log(userStore.userInfo)

// const refreshPage = () => {
//   sessionStorage.clear()
//   localStorage.removeItem('currentModuleKind')

//   window.location.reload()
//   showVersionDialog.value = false
// }
</script>

<style lang="scss">
:root {
  --primary-color: #D2475D;
  --primary-gradient: linear-gradient(315deg, #E34C65, #D2475D);
}

.v-btn {
  color: white !important;
  letter-spacing: 0.5px;
}

.v-btn.bg-primary.v-btn--variant-flat {
  background: var(--primary-gradient) !important;
  border: none !important;
  box-shadow: 0 2px 4px #D2475D !important;
}

.v-btn.v-btn--variant-flat:hover {
  box-shadow: 0 4px 12px #D2475D !important;
}

.v-btn.v-btn--variant-flat:active {
  box-shadow: 0 1px 4px #D2475D !important;
}

.v-btn.v-btn--variant-flat:disabled {
  background: linear-gradient(315deg, #E34C65, #D2475D) !important;
  box-shadow: none !important;
  opacity: 0.7;
}

.v-btn.error {
  background: linear-gradient(315deg, #E34C65, #D2475D) !important;
  box-shadow: 0 2px 8px rgba(255, 82, 82, 0.3) !important;
}

.v-btn.error:hover {
  box-shadow: 0 4px 12px #D2475D !important;
}

.v-btn.error:active {
  box-shadow: 0 1px 4px #D2475D !important;
}

.main-background {
  // min-height: calc(100vh - 64px);
  min-height: 100vh;
  padding: 16px;
  background-color: #2B2D33;
  box-sizing: border-box;
}

.content-container {
  max-width: 1500px;
  margin: 0 auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.v-select__selection-text{
  overflow: initial !important;
}
.v-snackbar__content {
  flex-grow: 1;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  line-height: 1.425;
  margin-right: auto;
  padding: 14px 16px;
  text-align: initial;
  word-wrap: break-word!important;
  word-break: break-all!important;
}
</style>
